<template>
  <div class="markers-wrapper">
    <div ref="canvasWrapper" :style="bgStyle">
      <div
        v-for="item in [
          ...propertyMarkers,
          ...subsectionMarkers,
          ...livingOptionMarkers
        ]"
        :key="item._id"
      >
        <polygon-shape
          :id="item._id"
          :title="polygonParentTitle"
          :polygon="item.polygon"
          :scale="scale"
          :isTagSelected="activeElement && activeElement._id === item._id"
          :isSelected="activeElement === item.polygon"
          @updatePolygon="item.polygon = $event"
          @clearSelection="clearSelection"
          @record-before-action="$emit('record-before-action', $event)"
          @record-action="$emit('record-action', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PolygonShape from "@/components/PolygonShape";

export default {
  props: [
    "active-element",
    "active-element-type",
    "property-ids",
    "subsection-ids",
    "living-option-ids",
    "zoom-level"
  ],

  components: {
    PolygonShape
  },

  data() {
    return {
      scale: 1,
      selectedPolygon: null,
      isTagSelected: false
    };
  },

  computed: {
    ...mapGetters([
      "activeLanguage",
      "page",
      "properties",
      "subsections",
      "livingOptions"
    ]),

    polygonParentTitle() {
      if (this.activeElementType === "polygon") {
        const parent = [
          ...this.propertyMarkers,
          ...this.subsectionMarkers,
          ...this.livingOptionMarkers
        ].find(marker => marker.polygon === this.activeElement);

        if (parent) {
          return parent.label;
        }
      }

      return "";
    },

    propertyMarkers() {
      if (this.propertyIds) {
        return this.properties.filter(property =>
          this.propertyIds.includes(property._id)
        );
      }

      return [];
    },

    subsectionMarkers() {
      if (this.subsectionIds) {
        return this.subsections.filter(subsection =>
          this.subsectionIds.includes(subsection._id)
        );
      }

      return [];
    },

    livingOptionMarkers() {
      if (this.livingOptionIds) {
        return this.livingOptions.filter(
          option => this.livingOptionIds.includes(option._id) && option.active
        );
      }

      return [];
    },

    bgStyle() {
      if (this.scale) {
        return {
          ["font-size"]: 20 * this.scale + "px",
          ["height"]: 1960 * this.scale + "px"
        };
      }
      return {};
    }
  },

  watch: {
    zoomLevel() {
      this.getScaledAmount();
    }
  },

  mounted() {
    window.addEventListener("resize", this.getScaledAmount);
    this.$nextTick(() => {
      this.getScaledAmount();
    });
  },

  methods: {
    getScaledAmount() {
      // default size based on 3190x1960 - scale = 1
      if (this.$refs.canvasWrapper) {
        let canvasWidth = this.$refs.canvasWrapper.getBoundingClientRect()
          .width;
        let scaled = canvasWidth / 3190;
        this.scale = scaled;
      }
    },

    updatePolygon(targetItem, polygon) {
      targetItem.polygon = polygon;
    },

    clearSelection() {
      this.$store.commit("draggable/deselectAll");
      this.$emit("selectedElement", null, "");
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.getScaledAmount);
  }
};
</script>

<style lang="scss" scoped>
.markers-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.dot {
  border-radius: 50%;
  background-color: red;
  cursor: pointer;
  pointer-events: all;
  position: absolute;
  font-size: 0.75em;
  height: 3em;
  width: 3em;
  user-select: none;
  opacity: 1;
  transform: translate(-0.25em, -0.4em);
  z-index: 6;

  &__label {
    background: #fff;
    bottom: 3.5em;
    left: 50%;
    opacity: 0;
    padding: 0.5em;
    pointer-events: none;
    position: absolute;
    transform: translateX(-50%);
    width: max-content;
  }

  &:hover {
    .dot__label {
      opacity: 1;
    }
  }

  &__status {
    background-color: rgba(#fff, 0.7);
    color: #000;
    font-size: 16px;
    padding: 10px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 6;

    input.form-control {
      display: inline-block;
      padding: 0 5px;
      width: 60px;
    }
  }
}

.inactive {
  opacity: 0.5;
}
</style>
